var _path, _path2, _path3, _path4, _path5, _circle, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06School(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8965 19.1309H7.89648V39.1309C7.89648 39.9593 13.7168 42.686 20.8965 42.686C28.0762 42.686 33.8965 39.9593 33.8965 39.1309V19.1309Z",
    fill: "#8F87F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8965 42.686C28.0762 42.686 33.8965 39.9593 33.8965 39.1309H20.8965V42.686Z",
    fill: "#353071"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90574 22.7915L20.8685 14.7474L33.9043 24.4914L33.9043 39.1483H20.8846L20.8837 34.7459L7.91106 26.0882L7.90574 22.7915Z",
    fill: "#353071"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91841 21.4992C1.27738 21.1097 1.27738 20.1794 1.91841 19.7899L20.3773 8.57522C20.6963 8.38139 21.0967 8.38139 21.4157 8.57522L39.8746 19.7899C40.5156 20.1794 40.5156 21.1097 39.8746 21.4992L21.4157 32.7138C21.0967 32.9077 20.6963 32.9077 20.3773 32.7138L1.91841 21.4992Z",
    fill: "#8F87F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3723 29.9398L31.3664 30.4988L31.4119 26.6292L21.5995 20.6677C21.2805 20.4739 21.2787 20.0115 21.5962 19.8151C21.7561 19.7162 21.958 19.7154 22.1188 19.8131L32.3782 26.0462L32.3723 29.9398Z",
    fill: "#E7E6F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9131,
    cy: 30.4961,
    r: 1,
    fill: "#4841A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8965 30.6445H30.8965L29.8965 34.6445C29.8965 35.1968 30.7919 35.6445 31.8965 35.6445C33.0011 35.6445 33.8965 35.1968 33.8965 34.6445L32.8965 30.6445Z",
    fill: "#4841A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06School);
export default __webpack_public_path__ + "static/media/06_school.b6349762ad0c283b1a0421ed34ca45a1.svg";
export { ForwardRef as ReactComponent };